import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";

const EditaVehiculoOrden = (props) => {
  const [data, setData] = useState(null);
  const [marcas, setMarcas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cargar datos del vehículo
  useEffect(() => {
    fetch(
      "https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerPropietariosPorVehiculo/" +
        props.idOrden,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          setData(data[0]);
        } else {
          setError(new Error("No data found"));
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setError(error);
        setLoading(false);
      });
  }, [props.idOrden]);

  // Cargar lista de marcas
  useEffect(() => {
    fetch("https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerMarcas")
      .then((res) => res.json())
      .then((data) => setMarcas(data))
      .catch((err) => console.error("Error al obtener marcas:", err));
  }, []);

  // Manejo de cambios
  const handleChange = (e) => {
    const { name, value } = e.target;
    const id = parseInt(e.target.dataset.id);

    setData((prevData) => {
      if (!prevData || !prevData.vehiculos) return prevData;

      const updated = {
        ...prevData,
        vehiculos: prevData.vehiculos.map((vehiculo) =>
          vehiculo.id === id ? { ...vehiculo, [name]: value } : vehiculo,
        ),
      };

      return updated;
    });
  };

  // Botón actualizar
  const BtnActualizar = async (e) => {
    e.preventDefault();
    try {
      const promises = data.vehiculos.map((vehiculo) =>
        axios({
          method: "put",
          auth: {
            username: "BasicAuth@icontec.org",
          },
          url: `https://inspecciongnvback.azurewebsites.net/api/v1/ActualizaVehiculo/${vehiculo.id}`,
          data: vehiculo,
        }),
      );
      const responses = await Promise.all(promises);
      responses.forEach((response) => {
        console.log(response.data);
      });
      alert("Vehículos actualizados con éxito!");
      window.location.reload("/");
    } catch (error) {
      console.error("Error updating vehicle:", error);
      alert("Error al actualizar los vehículos: " + error);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <form onSubmit={BtnActualizar}>
      <Container className="mt--1" fluid>
        <Card className="shadow">
          <CardBody>
            <Row>
              <Col>
                <h3>Información del Vehículo</h3>
                {data && data.vehiculos && data.vehiculos.length > 0 ? (
                  data.vehiculos.map((vehiculo, index) => (
                    <Row key={index}>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label">Placa</label>
                          <Input
                            className="form-control-alternative"
                            type="text"
                            name="placa"
                            data-id={vehiculo.id}
                            value={vehiculo.placa || ""}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label">Vin</label>
                          <Input
                            className="form-control-alternative"
                            type="text"
                            name="vin"
                            data-id={vehiculo.id}
                            value={vehiculo.vin || ""}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label">Modelo</label>
                          <Input
                            className="form-control-alternative"
                            type="text"
                            name="modelo"
                            data-id={vehiculo.id}
                            value={vehiculo.modelo || ""}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="4">
                        <FormGroup>
                          <label className="form-control-label">
                            Tipo Vehículo
                          </label>
                          <Input
                            className="form-control-alternative"
                            type="text"
                            name="tipoVehiculo"
                            data-id={vehiculo.id}
                            value={vehiculo.tipoVehiculo || ""}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label">Marca</label>
                          <Input
                            type="select"
                            name="idMarca"
                            data-id={vehiculo.id}
                            value={vehiculo.idMarca || ""}
                            onChange={handleChange}
                          >
                            <option value="">Seleccione una marca</option>
                            {marcas.map((marca) => (
                              <option key={marca.id} value={marca.id}>
                                {marca.marca}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  ))
                ) : (
                  <div>No hay información disponible</div>
                )}
              </Col>
            </Row>

            <Button color="primary" type="submit">
              Actualizar Vehículos
            </Button>
          </CardBody>
        </Card>
      </Container>
    </form>
  );
};

export default EditaVehiculoOrden;
